// this is hidden config of reactjs
// - npm start => process.env.NODE_ENV === 'development'
// - npm run build => process.env.NODE_ENV === 'production'

export const API_HOST_NAME = (process.env.NODE_ENV === 'production') 
                                    ? 'https://apiwh.season.vn' // live 
                                    // : 'http://127.0.0.1:8000' // debug
                                    // : 'https://api24.ntfsoft.com' // dev remote
                                    // : 'http://apiseason.test' // dev local
                                    : 'http://api24.local:801' // dev docker
                                    // : 'https://apiwh.season.vn'